import {UntypedFormControl, ValidatorFn} from '@angular/forms'

export function audioRecorderValidator(): ValidatorFn {
  return function validate(formControl: UntypedFormControl) {
    const audioFile = formControl.value;
    if(!audioFile?.length) {
      return {noRecordingValidator: true}
    }
    return null
  }
}
